import ModalComponent from '../../components/ModalComponent';

interface Props {
  open: boolean
  pageTitle: string
  isPublished?: boolean
  handleClose: () => void
  handleSave: () => void
}

const Index = (props: Props) => {
  const {
    open, pageTitle, isPublished, handleClose, handleSave,
  } = props;

  return (
    <>
      <ModalComponent
        title={isPublished ? 'Error' : 'Delete'}
        confirmButtonText="Delete"
        confirmButtonColor="danger"
        hideConfirmButton={!!isPublished}
        cancelButtonText={isPublished ? 'Close' : 'Cancel'}
        footerClass="justify-content-center"
        cancelButtonColor="outline-secondary"
        onConfirm={handleSave}
        show={open}
        closeModal={handleClose}
        centered
        animation={false}
      >
        {isPublished
          ? (<p className="mb-0 text-center">Published pages cannot be deleted.</p>)
          : (
            <p className="mb-0">
              Are you sure you want to delete &quot;
              {pageTitle}
              &quot;?
            </p>
          )}
      </ModalComponent>
    </>
  );
};

export default Index;
